import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { isBillingAccount } from 'services/is_billing_account';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';
import { useAccount } from 'hooks/api/useAccount';

export function useHasValidPaymentMethods(
  options?: UseQueryOptions<boolean, APIError>
) {
  const { client } = useAPI();
  const { data: organization } = useCurrentOrganization();
  const { data: account } = useAccount();

  return useAuthenticatedQuery(
    ['has_payment_methods', 'org', organization?.id],
    async () => {
      if (!organization) {
        return Promise.reject(new Error('No organization.'));
      }

      if (!isBillingAccount(account, organization.id)) {
        return Promise.reject(new Error('Not authorized.'));
      }

      const { data } = await client.get<boolean>(
        `/internal/orgs/${organization.id}/has_valid_payment_methods`
      );
      return data;
    },
    options
  );
}
